export default {
  // Styles
  dotSize: 6,
  touchableSize: 48,

  // Values
  dayInMs: 1000 * 60 * 60 * 24,
  weekLength: 7,
  todayDate: new Date().toISOString().split('T')[0],
  monthHeaderHeight: 72,
};
